firebird.controller('e2eeMeetingFullCtrl', [
    'meetingService',
    function (meetingService) {
        var self = this;
        self.getAppLogoURL = meetingService.getAppLogoURL;
    }
]);
